// for ReactDnD

export const ItemTypes = {
  CARD: "card"
};
